import { styled } from 'styled-components'

const ScreenContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%; /* Ensure it matches the parent's height */
  background: transparent;
  overflow: visible;
  box-sizing: border-box;
`
export default ScreenContainer
